import { useSearchParams } from 'react-router-dom';
import { KollabHRLogo } from '@gokrew/ui/assets';
import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';

export function MockSessionExpiredPage() {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation(TranslationNS.Auth);
  const wasEnded = searchParams.get('ended') === 'true';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <img className="w-16" src={KollabHRLogo} alt="Logo" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          {wasEnded ? t('mock_session_expired.ended_title') : t('mock_session_expired.expired_title')}
        </h2>
        <p className="text-gray-500 text-sm">
          {wasEnded ? t('mock_session_expired.ended_message') : t('mock_session_expired.expired_message')}
        </p>
      </div>
    </div>
  );
}
